import { Injectable } from '@angular/core';
import { EnvironmentService } from '../environment.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MasterService {
  private readonly apiBaseURL: string;
  private readonly pybaseURL: string;

  constructor(
    private environmentService: EnvironmentService,
    private readonly http: HttpClient
  ) {
    this.apiBaseURL = this.environmentService.getApiEndpoint();
    this.pybaseURL = this.environmentService.getPyBaseEndpoint();
  }


  token = localStorage.getItem('token');

  getMasterDataList(pagenumber: number, numberofitemsperpage: number, sortfield: any, sortorder: any, modeltype: string, search?: any, filters?: any): Observable<any> {
    let headers = new HttpHeaders().append('Authorization', `Bearer ${this.token}`);
    let params = new HttpParams()
      .set('page', pagenumber.toString())
      .set('size', numberofitemsperpage.toString())
      .set('orderby', sortfield.toString())
      .set('order', sortorder.toString())
      .set('modeltype', modeltype.toString())
      .set('search', search.toString());
    if (filters && typeof filters === 'object') {
      Object.keys(filters).forEach((key) => {
        const field = filters[key];
        if (Array.isArray(field) && field.length > 0) {
          field.forEach((item: any, index: number) => {
            params = params
              .set(`filters[${key}][${index}][value]`, item.value)
              .set(`filters[${key}][${index}][matchMode]`, item.matchMode || 'contains');
          });
        }
      });
    }
    return this.http.get<any>(`${this.apiBaseURL}policy-allowance-benefits`, { headers, params });
  }

  getAllMaster() {
    return this.http.get<any>(`${this.apiBaseURL}policy-allowance-benefits/getAllPolicy`);
  }

  createMaster(formData: any): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', `Bearer ${this.token}`);
    let options = {
      headers: headers
    }
    return this.http.post<any>(`${this.apiBaseURL}policy-allowance-benefits/create`, formData, options);
  }


  updateMaster(formData: any, id: any): Observable<any> {
    const token = localStorage.getItem('token');
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', `Bearer ${token}`);
    let options = {
      headers: headers
    }
    return this.http.put<any>(this.apiBaseURL + 'policy-allowance-benefits/update/' + id, formData, options)
  }

  deleteMaster(id: any): Observable<any> {
    const token = localStorage.getItem('token');
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', `Bearer ${token}`);
    let options = {
      headers: headers
    }
    return this.http.delete<any>(this.apiBaseURL + 'policy-allowance-benefits/delete/' + id, options)
  }

  viewMaster(id: any, modeltype: string): Observable<any> {
    let headers = new HttpHeaders().append('Authorization', `Bearer ${this.token}`);
    let params = new HttpParams().set('modeltype', modeltype.toString())
    return this.http.get<any>(this.apiBaseURL + 'policy-allowance-benefits/view/' + id, { headers, params })
  }

  getAllAcknowledgement(params = {}) {
    let options = {
      params: new HttpParams({ fromObject: params }),
    };
    return this.http.get<any>(`${this.apiBaseURL}policy-allowance-benefits/getAllAcknowledgement`, options);
  }

  extractTextFromFile(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`${this.pybaseURL}convert-to-html`, formData);
  }
}
